import React from 'react';
import Icon from '../../../components/AppIcon';
import Select from '../../../components/ui/Select';
import { Checkbox } from '../../../components/ui/Checkbox';
import Button from '../../../components/ui/Button';

const FilterPanel = ({ filters, onFilterChange, onReset }) => {
  const categoryOptions = [
    { value: 'all', label: 'All Categories' },
    { value: 'forest', label: 'Forest Ecosystem' },
    { value: 'marine', label: 'Marine & Coastal' },
    { value: 'wetland', label: 'Wetland Areas' },
    { value: 'mountain', label: 'Mountain Zones' },
    { value: 'grassland', label: 'Grassland Habitats' }
  ];

  const seasonOptions = [
    { value: 'all', label: 'All Seasons' },
    { value: 'dry', label: 'Dry Season (Nov-Apr)' },
    { value: 'wet', label: 'Wet Season (May-Oct)' }
  ];

  const accessibilityOptions = [
    { value: 'all', label: 'All Access Levels' },
    { value: 'easy', label: 'Easy Access' },
    { value: 'moderate', label: 'Moderate Access' },
    { value: 'difficult', label: 'Difficult Access' }
  ];

  return (
    <div className="bg-[var(--color-card)] rounded-lg p-6 shadow-conservation border border-[var(--color-border)]">
      <div className="flex items-center justify-between mb-6">
        <h3 className="text-lg font-semibold text-[var(--color-foreground)]">Filter Zones</h3>
        <Button variant="ghost" size="sm" onClick={onReset}>
          <Icon name="RotateCcw" size={16} />
          <span className="ml-2 text-[var(--color-foreground)]">Reset</span>
        </Button>
      </div>
      <div className="space-y-6">
        {/* Category Filter */}
        <div>
          <Select
            label="Ecosystem Type"
            options={categoryOptions}
            value={filters?.category}
            onChange={(value) => onFilterChange('category', value)}
          />
        </div>

        {/* Season Filter */}
        <div>
          <Select
            label="Best Season"
            options={seasonOptions}
            value={filters?.season}
            onChange={(value) => onFilterChange('season', value)}
          />
        </div>

        {/* Accessibility Filter */}
        <div>
          <Select
            label="Accessibility Level"
            options={accessibilityOptions}
            value={filters?.accessibility}
            onChange={(value) => onFilterChange('accessibility', value)}
          />
        </div>

        {/* Conservation Status */}
        <div>
          <label className="text-sm font-medium text-[var(--color-foreground)] mb-3 block">
            Conservation Status
          </label>
          <div className="space-y-2">
            <Checkbox
              label="Excellent (80-100%)"
              checked={filters?.conservationStatus?.includes('excellent')}
              onChange={(e) => {
                const newStatus = e?.target?.checked
                  ? [...filters?.conservationStatus, 'excellent']
                  : filters?.conservationStatus?.filter(s => s !== 'excellent');
                onFilterChange('conservationStatus', newStatus);
              }}
            />
            <Checkbox
              label="Good (60-79%)"
              checked={filters?.conservationStatus?.includes('good')}
              onChange={(e) => {
                const newStatus = e?.target?.checked
                  ? [...filters?.conservationStatus, 'good']
                  : filters?.conservationStatus?.filter(s => s !== 'good');
                onFilterChange('conservationStatus', newStatus);
              }}
            />
            <Checkbox
              label="Moderate (40-59%)"
              checked={filters?.conservationStatus?.includes('moderate')}
              onChange={(e) => {
                const newStatus = e?.target?.checked
                  ? [...filters?.conservationStatus, 'moderate']
                  : filters?.conservationStatus?.filter(s => s !== 'moderate');
                onFilterChange('conservationStatus', newStatus);
              }}
            />
          </div>
        </div>

        {/* Features */}
        <div>
          <label className="text-sm font-medium text-[var(--color-foreground)] mb-3 block">
            Special Features
          </label>
          <div className="space-y-2">
            <Checkbox
              label="Endemic Species"
              checked={filters?.features?.includes('endemic')}
              onChange={(e) => {
                const newFeatures = e?.target?.checked
                  ? [...filters?.features, 'endemic']
                  : filters?.features?.filter(f => f !== 'endemic');
                onFilterChange('features', newFeatures);
              }}
            />
            <Checkbox
              label="Endangered Species"
              checked={filters?.features?.includes('endangered')}
              onChange={(e) => {
                const newFeatures = e?.target?.checked
                  ? [...filters?.features, 'endangered']
                  : filters?.features?.filter(f => f !== 'endangered');
                onFilterChange('features', newFeatures);
              }}
            />
            <Checkbox
              label="Research Sites"
              checked={filters?.features?.includes('research')}
              onChange={(e) => {
                const newFeatures = e?.target?.checked
                  ? [...filters?.features, 'research']
                  : filters?.features?.filter(f => f !== 'research');
                onFilterChange('features', newFeatures);
              }}
            />
            <Checkbox
              label="Visitor Facilities"
              checked={filters?.features?.includes('facilities')}
              onChange={(e) => {
                const newFeatures = e?.target?.checked
                  ? [...filters?.features, 'facilities']
                  : filters?.features?.filter(f => f !== 'facilities');
                onFilterChange('features', newFeatures);
              }}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default FilterPanel;